function catalogPhoto(){
    const imagesBlocks = document.querySelectorAll('.catalog-photo');
    imagesBlocks.forEach((imagesBlock) => {
        imagesBlock.addEventListener('mouseover', (e) => {
            const target = e.target;
            if (target.classList.contains('catalog-photo__item')) {
                const images = target.parentNode.querySelectorAll('.catalog-photo__item');
                images.forEach((img) => {
                    img.classList.remove('catalog-photo__item_selected');
                });
                target.classList.add('catalog-photo__item_selected');
                const parent = target.parentNode.parentNode;
                parent.querySelector('img').src = target.dataset.dopSrc;
            }
        });
    });
}

export default catalogPhoto;